import React, { useEffect, useState } from "react";
import Sidebar from "../StudentSidebar/Sidebar";
import StudentNavbar from "../StudentNavbar/StudentNavbar";
import { PngImages, SvgImages } from "../../Utils/LocalImages";
import Image from "../../Components/Reusable/Image";
import RoutesPath from "../../Utils/RoutesPath";
import { Link, useNavigate, useParams } from "react-router-dom";
import StudentDashboardServices from "../../Services/StudentDashboardApiService";
import { handleApiErrors } from "../../Utils/Utils";
import { FaCheck } from "react-icons/fa6";
import { HiX } from "react-icons/hi";
import parse from "html-react-parser";
import { CirclesWithBar } from "react-loader-spinner";
import SubmitButtonTwo from "../../Components/Reusable/Buttontwo";

const ViewResults = () => {
    const [activeTab, setActiveTab] = useState('');
    const [openIndex, setOpenIndex] = useState(null);
    const { mockTest_id, mockTestSubmissions_id } = useParams();
    const [loading, setLoading] = useState(false);
    const [selectedSubjectId, setSelectedSubjectId] = useState(null);
    const [subjects, setSubjects] = useState([]);
    const [allQuestions, setAllQuestions] = useState([]);
    const [testDetails, setTestDetails] = useState({});

    const [cumulativeCount, setCumulativeCount] = useState(1); // To track the continuous question index across subjects
    const [subjectStartingIndexes, setSubjectStartingIndexes] = useState({}); // Store the initial question index for each subject
    const [lastQuestionIndex, setLastQuestionIndex] = useState({}); // To store the last question index for each subject
    const [currentSubjectIndex, setCurrentSubjectIndex] = useState(0);


    useEffect(() => {
        if (mockTest_id && mockTestSubmissions_id) {
            getAllResultByID(mockTest_id, mockTestSubmissions_id);
        }
    }, [mockTest_id, mockTestSubmissions_id]);


    const getAllResultByID = async (mockTest_id, mockTestSubmissions_id, subject_id = null) => {
        setLoading(true);
        try {
            const response = await StudentDashboardServices.getAllResultByID(mockTest_id, mockTestSubmissions_id, subject_id);
            const { subjects, questions, ...rest } = response.data;
            if (subject_id === null && subjects.length > 0) {
                const defaultSubject = subjects[0];
                setSelectedSubjectId(defaultSubject.subjectId);
                setActiveTab(defaultSubject.subjectName);
                return getAllResultByID(mockTest_id, mockTestSubmissions_id, defaultSubject.subjectId);
            }
            if (Array.isArray(questions) && questions.length > 0) {
                // Set the starting index for each subject the first time it's loaded
                if (subject_id && !subjectStartingIndexes[subject_id]) {
                    setSubjectStartingIndexes(prev => ({
                        ...prev,
                        [subject_id]: cumulativeCount,  // Set the initial index for this subject
                    }));
                }

                var questionCount = 0;
                for (const question of questions) {
                    if (question.typeOfQuestion === "Comprehensive" || question.typeOfQuestion === "Poem") {
                        questionCount += question?.subQuestions?.length || 0;
                    } else {
                        questionCount++;
                    }
                }
                // Update the last question index for the current subject
                setLastQuestionIndex(prev => ({
                    ...prev,
                    [subject_id]: cumulativeCount + questionCount - 1, // The last question index for this subject
                }));

                // Update cumulative count for continuous indexing
                setCumulativeCount(prevCount => prevCount + questionCount);
            } else {
                console.error('Questions is invalid or empty');
            }


            setSubjects(subjects);
            setAllQuestions(questions);
            setTestDetails(rest);

        } catch (error) {
            handleApiErrors(error);
        } finally {
            setLoading(false);
        }
    };
    const selectedSubjectSummary = subjects.find(
        (subject) => subject.subjectId === selectedSubjectId
    );
    const handleToggleSolution = (index) => {
        // Toggle solution visibility
        setOpenIndex(openIndex === index ? null : index);
    };
    // const handleSubjectChange = (subjectId, subjectName) => {
    //     setActiveTab(subjectName);
    //     setSelectedSubjectId(subjectId);
    //     getAllResultByID(mockTest_id, mockTestSubmissions_id, subjectId);
    // };

    useEffect(() => {
        if (subjects.length > 0 && selectedSubjectId === null) {
            const firstSubject = subjects[0];
            setSelectedSubjectId(firstSubject.subjectId);
            setActiveTab(firstSubject.subjectName);
        }
    }, [subjects, selectedSubjectId]);

    const handleSubjectChange = (direction, subjectId = null, subjectName = null) => {
        scrollToTop();        
        let newIndex = currentSubjectIndex;
        let newCumulativeCount = cumulativeCount;

        // Logic for "next" button click
        if (direction === 'next' && currentSubjectIndex < subjects.length - 1) {
            newIndex = currentSubjectIndex + 1;
        }
        // Logic for "previous" button click
        else if (direction === 'previous' && currentSubjectIndex > 0) {
            newIndex = currentSubjectIndex - 1;
        }
        // Handle tab click navigation
        else if (subjectId !== null && subjectName !== null) {
            // Find the index of the clicked subject based on subjectId
            const clickedSubjectIndex = subjects.findIndex(subject => subject.subjectId === subjectId);
            if (clickedSubjectIndex !== -1) {
                newIndex = clickedSubjectIndex;
            }
        }

        const currentSubject = subjects[newIndex];
        const currentSubjectId = currentSubject?.subjectId;

        // Ensure that we are using the correct cumulative index for this subject
        if (currentSubjectId && subjectStartingIndexes[currentSubjectId] !== undefined) {
            newCumulativeCount = subjectStartingIndexes[currentSubjectId]; // Start from the stored index for this subject
        }

        // Update the state and UI
        setCurrentSubjectIndex(newIndex); // Update current subject index
        setSelectedSubjectId(currentSubject?.subjectId); // Update selected subject ID
        setActiveTab(currentSubject?.subjectName); // Update active tab

        // Update cumulative count
        setCumulativeCount(newCumulativeCount); // Update cumulative count for continuous indexing

        // Fetch the subject data again with updated cumulative count
        getAllResultByID(mockTest_id, mockTestSubmissions_id, currentSubject?.subjectId);
    };
    const getAlphabetLabel = (index) => {
        const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        return letters[index] || "";
    };
    const decodeHtml = (html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        return doc.documentElement.innerHTML;
    };
    const decodeHtmlopt = (html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        return doc.documentElement.textContent;
    };

    const customParser = (node) => {
        if (node.name === "oembed") {
            const url = node.attribs.url;
            let videoId;
            // Handle both normal YouTube URLs (youtube.com) and short URLs (youtu.be)
            if (url.includes("youtube.com")) {
                videoId = new URL(url).searchParams.get("v");  // Extract the video ID from the "v" parameter
            } else if (url.includes("youtu.be")) {
                videoId = url.split("/").pop().split("?")[0];  // Extract the ID after the last "/"
            }
            if (videoId) {
                return (
                    <iframe
                        width="560"
                        height="315"
                        src={`https://www.youtube.com/embed/${videoId}`}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        title="YouTube video"
                    />
                );
            } else {
                return <p className='text-danger'>Invalid YouTube URL</p>;
            }
        }
    };
    const cleanQuestionText = (text) => {
        return text.replace(/&nbsp;/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();
    };
    const scrollToTop = () => {
        document.getElementById("scroll_bar1").scroll(0,0)
      }
    return (
        <div className="d-flex">
            <Sidebar />
            <div className="mainLayout-content">
                <StudentNavbar />
                <div className="main_content contentSection scroll_bar"id="scroll_bar1">
                    <div className="mb-4 d-flex justify-content-between align-items-center">
                        <h1 className="black sub-large-text-one fw-700 mb-0">{testDetails.mockTestName}</h1>
                        <Link to={`${RoutesPath.showresult}/${mockTest_id}/${testDetails.order_id}`}>
                            <div className="d-flex" style={{ paddingRight: "10px" }}>
                                <h4 className="Caption fw-600  mb-0"><span className='orangeAccentColor'>Back</span> &gt;</h4>
                            </div>
                        </Link>
                    </div>

                    <div className="table_container" style={{ display: "block" }}>
                        <div className="Performancesection">
                            <div>
                                <h3 className="blue small-medium-text fw-700 mb-0">My Overall Performance Summary</h3>
                            </div>

                            <div className="d-flex row  mt-4">
                                <div className="d-flex mb-2 col-md-3 col-sm-3 col-6 gap-2 align-items-center">
                                    <div className="view-result-icon green">
                                        <Image src={PngImages.fileplus} />
                                    </div>
                                    <div>
                                        <h3 className=" medium-text fw-600 mb-0">{Math.max(testDetails.score, 0)}/{testDetails.totalMarks}</h3>
                                        <span className="small-text captioncolor fw-500">Marks</span>
                                    </div>
                                </div>
                                <div className="d-flex mb-2 col-md-3 col-sm-3 col-6 gap-2 align-items-center ">
                                    <div className="view-result-icon golden">
                                        <Image src={PngImages.attempted} />
                                    </div>
                                    <div>
                                        <h3 className=" medium-text fw-600 mb-0">{testDetails.totalAttemptQuestions}/{testDetails.totalQuestions}</h3>
                                        <span className="small-text captioncolor fw-500">Attempted</span>
                                    </div>
                                </div>

                                <div className="d-flex mb-2 col-md-3 col-sm-3 col-6 gap-2 align-items-center">
                                    <div className="view-result-icon pink">
                                        <Image src={PngImages.correct} />
                                    </div>
                                    <div>
                                        <h3 className=" medium-text fw-600 mb-0">{testDetails.totalCorrectQuestions}/{testDetails.totalQuestions}</h3>
                                        <span className="small-text captioncolor fw-500">Correct</span>
                                    </div>
                                </div>

                                <div className="d-flex mb-2 col-md-3 col-sm-3 col-6 gap-2 align-items-center">
                                    <div className="view-result-icon orangebg">
                                        <Image src={PngImages.incorrect} />
                                    </div>
                                    <div>
                                        <h3 className=" medium-text fw-600 mb-0">{testDetails.totalIncorrectQuestions}/{testDetails.totalQuestions}</h3>
                                        <span className="small-text captioncolor fw-500">Incorrect</span>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <h3 className="blue small-medium-text fw-700 mb-0 mt-4">Total Time Taken</h3>
                            </div>
                            <div className="d-flex row mt-4">
                                <div className="d-flex  mb-2 col-md-3  col-sm-3 col-6  gap-2 align-items-center">
                                    <div className="view-result-icon darkblue">
                                        <Image src={PngImages.timeicon} />
                                    </div>

                                    <div>
                                        <span className="small-text captioncolor fw-500 text-truncate">hh : mm : ss</span>
                                        <h3 className=" medium-text fw-600 mb-0 text-capitalize text-truncate">{testDetails.startTime}</h3>
                                        <span className="small-text captioncolor fw-500">Start Time</span>
                                    </div>
                                </div>
                                <div className="d-flex  mb-2 col-md-3 col-sm-3 col-6  gap-2 align-items-center">
                                    <div className="view-result-icon darkpurple">
                                        <Image src={PngImages.timeicon} />
                                    </div>
                                    <div>
                                        <span className="small-text captioncolor fw-500 text-truncate">hh : mm : ss</span>
                                        <h3 className=" medium-text fw-600 mb-0 text-capitalize text-truncate">{testDetails.endTime}</h3>
                                        <span className="small-text captioncolor fw-500">End Time</span>
                                    </div>
                                </div>
                                <div className="d-flex  mb-2 col-md-3 col-sm-3 col-6  gap-2 align-items-center">
                                    <div className="view-result-icon magenta">
                                        <Image src={PngImages.time_taken} />
                                    </div>
                                    <div>
                                        <span className="small-text captioncolor fw-500 text-truncate">hh : mm : ss</span>
                                        <h3 className=" medium-text fw-600 mb-0 text-truncate">{testDetails.submittedTime}</h3>
                                        <span className="small-text captioncolor fw-500">Time Taken</span>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div>
                            <ul className="small-medium-text overflow-auto fw-600 list-group list-group-horizontal gap-1 mb-3 mt-4 text-white">
                                {subjects.map(subject => (
                                    <li
                                        key={subject.subjectId}
                                        className={`list-group-item border-0 ${activeTab === subject.subjectName ? 'active' : ''}`}
                                        onClick={() => handleSubjectChange(null, subject.subjectId, subject.subjectName)}
                                        style={{ cursor: 'pointer', borderRadius: "6px", backgroundColor: activeTab === subject.subjectName ? '#F6821F' : 'transparent' }}
                                    >
                                        {subject.subjectName}
                                    </li>
                                ))}
                            </ul>

                            <div className="Performancesection">
                                <div>
                                    <h3 className="blue small-medium-text fw-700 mb-0">Subject Performance Summary</h3>
                                </div>

                                <div className="d-flex row mt-4">
                                    <div className="d-flex mb-2 col-md-3 col-sm-3 col-6 gap-2 align-items-center">
                                        <div className="view-result-icon green">
                                            <Image src={PngImages.fileplus} />
                                        </div>
                                        <div>
                                            <h3 className=" medium-text fw-600 mb-0">{Math.max(selectedSubjectSummary?.score, 0)}/{selectedSubjectSummary?.totalQuestions * 2}</h3>
                                            <span className="small-text captioncolor fw-500">Marks</span>
                                        </div>
                                    </div>

                                    <div className="d-flex mb-2 col-md-3 col-sm-3 col-6 gap-2 align-items-center ">
                                        <div className="view-result-icon golden">
                                            <Image src={PngImages.attempted} />
                                        </div>
                                        <div>
                                            <h3 className=" medium-text fw-600 mb-0">{selectedSubjectSummary?.attemptedQuestions}/{selectedSubjectSummary?.totalQuestions}</h3>
                                            <span className="small-text captioncolor fw-500">Attempted</span>
                                        </div>
                                    </div>

                                    <div className="d-flex mb-2 col-md-3 col-sm-3 col-6 gap-2 align-items-center">
                                        <div className="view-result-icon pink">
                                            <Image src={PngImages.correct} />
                                        </div>
                                        <div>
                                            <h3 className=" medium-text fw-600 mb-0">{selectedSubjectSummary?.correctQuestions}/{selectedSubjectSummary?.totalQuestions}</h3>
                                            <span className="small-text captioncolor fw-500">Correct</span>
                                        </div>
                                    </div>

                                    <div className="d-flex mb-2 col-md-3 col-sm-3 col-6 gap-2 align-items-center">
                                        <div className="view-result-icon orangebg">
                                            <Image src={PngImages.incorrect} />
                                        </div>
                                        <div>
                                            <h3 className=" medium-text fw-600 mb-0">{selectedSubjectSummary?.incorrectQuestions}/{selectedSubjectSummary?.totalQuestions}</h3>
                                            <span className="small-text captioncolor fw-500">Incorrect</span>
                                        </div>
                                    </div>
                                </div>


                            </div>
                            <section className='small-medium-text fw-600 my-4'>

                                {loading ? (
                                    <div className="text-center d-flex justify-content-center">
                                        <CirclesWithBar
                                            height="80"
                                            width="80"
                                            color="#F6821F"
                                            ariaLabel="bars-loading"
                                            wrapperStyle={{}}
                                            wrapperClass=""
                                        />
                                    </div>
                                ) : (
                                    <>
                                        {
                                            allQuestions.map((q, index) => {
                                                var continuousIndex = subjectStartingIndexes[selectedSubjectId];
                                                for (var i = 0; i < index; i++) {
                                                    continuousIndex += (allQuestions[i]?.subQuestions?.length || 1);
                                                }
                                                return (
                                                    <div key={index} className='my-4 border-question pb-4'>
                                                        <div className="small-medium-text fw-600 mb-3">
                                                            {q.heading} <span style={{ color: q.markColor }}>{q.marks}</span>
                                                        </div>

                                                        <div className="small-medium-text fw-600 mb-3 d-flex justify-content-start text-center gap-1">
                                                            {/* Question {index + 1} */}
                                                            Question {q.typeOfQuestion == "Comprehensive" || q.typeOfQuestion == "Poem" ? "" : continuousIndex}
                                                            <div>
                                                                {
                                                                    q.typeOfQuestion === 'General' && (
                                                                        q.selectedOption === null ? (
                                                                            null  // Show "Not Answered" if no option is selected
                                                                        ) : (
                                                                            q.correctOption === q.selectedOption ? (
                                                                                <span style={{ color: "#008000" }}>(+2 marks)</span>  // Show marks only if an option is selected
                                                                            ) : (
                                                                                q.negativeMarking==="Yes"?
                                                                                <span style={{ color: "#FF0000" }}>(0.5 marks)</span> :null
                                                                                // Incorrect option, show 0.5 marks
                                                                            )
                                                                        )
                                                                    )
                                                                }
                                                            </div>
                                                        </div>

                                                        {q.typeOfQuestion === 'Comprehensive' || q.typeOfQuestion === 'Poem' ? (
                                                            <div>
                                                                {q?.typeOfQuestion === 'Comprehensive' || q?.typeOfQuestion === 'Poem' ? (

                                                                    <div className=" blog-data-html" style={{ contain: "content", width: '90%' }}>
                                                                        {cleanQuestionText(q.question) && parse(cleanQuestionText(q.question), { replace: customParser })}

                                                                    </div>

                                                                ) : (
                                                                    null

                                                                )}

                                                                {q.subQuestions.map((subQ, subIndex) => {
                                                                    if (subIndex != 0) {
                                                                        continuousIndex++;
                                                                    }
                                                                    const subQuestionNumber = `${continuousIndex}.${subIndex + 1}`; // e.g., 1.1, 1.2
                                                                    return (
                                                                        <div key={subIndex} className='my-4'>
                                                                            {/* <div className=" d-flex justify-content-between">
                                                                        <div className="small-medium-text fw-600 text-dark d-flex gap-2">
                                                                            <span>{subIndex + 1}.</span>{decodeHtml(subQ.question.replace(/&nbsp;/g, ' '))}
                                                                            <div>
                                                                                {subQ.selectedOption === null ? (
                                                                                    null
                                                                                ) : (
                                                                                    subQ.correctOption === subQ.selectedOption ? (
                                                                                        <span style={{ color: "#008000" }}>(+2 marks)</span>  // Correct answer
                                                                                    ) : (
                                                                                        <span style={{ color: "#FF0000" }}>(0.5 marks)</span>  // Incorrect answer
                                                                                    )
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                        <div>
                                                                            {subQ.selectedOption == null ? (
                                                                                <span style={{ color: "#FF0000" }}>Not Answered</span>
                                                                            ) : (
                                                                                null
                                                                            )}
                                                                        </div>
                                                                    </div> */}
                                                                            <div className=" d-flex justify-content-between">
                                                                                <div className="d-flex gap-2 align-items-center">
                                                                                    <div className="small-medium-text fw-600 text-dark d-flex  align-items-center gap-2">

                                                                                        <div style={{ marginBottom: '9px' }}>{continuousIndex}.</div>
                                                                                        {q?.typeOfQuestion === 'Poem' || 'Comprehensive' ? (

                                                                                            <div className="w-100 blog-data-html mt-2" style={{ contain: "content" }}>
                                                                                                {cleanQuestionText(subQ?.question) && parse(cleanQuestionText(subQ.question), { replace: customParser })}
                                                                                            </div>

                                                                                        ) : (
                                                                                            null

                                                                                        )}

                                                                                    </div>

                                                                                    <div style={{ marginBottom: '9px' }}>
                                                                                        {subQ.selectedOption === null ? (
                                                                                            null
                                                                                        ) : (
                                                                                            subQ.correctOption === subQ.selectedOption ? (
                                                                                                <span style={{ color: "#008000" }}>(+2 marks)</span>  // Correct answer
                                                                                            ) : (
                                                                                                 q.negativeMarking==="Yes"?
                                                                                <span style={{ color: "#FF0000" }}>(0.5 marks)</span> :null // Incorrect answer
                                                                                            )
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                                <div>
                                                                                    {subQ.selectedOption == null ? (
                                                                                        <span style={{ color: "#FF0000" }}>Not Answered</span>
                                                                                    ) : (
                                                                                        null
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                            <ol className="list-group mt-4">
                                                                                {subQ.options.map((option, optIndex) => {
                                                                                    const isUserSelected = subQ.selectedOption === optIndex;
                                                                                    const isCorrectOption = subQ.correctOption === optIndex;

                                                                                    return (
                                                                                        <li
                                                                                            key={optIndex}
                                                                                            className="list-group-item d-flex gap-2 justify-content-between align-items-start border-0 py-0"
                                                                                            style={{
                                                                                                color: isCorrectOption ? 'green' : (isUserSelected && !isCorrectOption) ? 'red' : 'inherit',
                                                                                            }}
                                                                                        >
                                                                                            <div className="ms-2 me-auto form-check d-flex align-items-center p-0">
                                                                                                <div className="checkmarks"
                                                                                                    style={{
                                                                                                        border: isCorrectOption ? 'none' : (isUserSelected && !isCorrectOption ? 'red' : '1px solid #ccc'),
                                                                                                        backgroundColor: isCorrectOption ? 'green' : (isUserSelected && !isCorrectOption ? 'red' : 'white'),
                                                                                                        marginBottom: "16px"
                                                                                                    }}
                                                                                                >
                                                                                                    {isUserSelected && !isCorrectOption ? <HiX style={{ fontSize: '16px' }} /> : (isCorrectOption ? <FaCheck style={{ fontSize: '15px' }} /> : '')}                                                                  </div>
                                                                                                <label
                                                                                                    className="form-check-label small-medium-text fw-500 px-2  "
                                                                                                    htmlFor={`Comprehensive-option-${index}-${subIndex}`}
                                                                                                >
                                                                                                    <div className="d-flex gap-2">
                                                                                                        <span style={{ marginTop: '2px' }}>{getAlphabetLabel(optIndex)}. </span> <span>{cleanQuestionText(option) && parse(cleanQuestionText(option), { replace: customParser })}</span>
                                                                                                        <div className="text-end" style={{ marginTop: '2px' }}>
                                                                                                            {isCorrectOption && !isUserSelected && (
                                                                                                                <span className="small-text ms-3 fw-600" style={{ fontStyle: 'italic' }}>Correct Answer</span>
                                                                                                            )}
                                                                                                            {isUserSelected && !isCorrectOption && (
                                                                                                                <span className="text-danger small-text ms-3 fw-600" style={{ fontStyle: 'italic' }}>Incorrect Answer</span>
                                                                                                            )}
                                                                                                            {isUserSelected && isCorrectOption && (
                                                                                                                <span className="small-text ms-3 fw-600" style={{ fontStyle: 'italic' }}>Your Answer</span>
                                                                                                            )}
                                                                                                        </div>
                                                                                                    </div>

                                                                                                </label>
                                                                                            </div>
                                                                                        </li>
                                                                                    );
                                                                                })}
                                                                            </ol>
                                                                            {subQ.solution !== "" ? (
                                                                                <div className="d-flex gap-2 align-items-center mt-2">
                                                                                    <div className='d-flex gap-1 align-items-center'>
                                                                                        <Image src={PngImages.light_bulb} alt="Light Bulb Icon" />
                                                                                        <div>
                                                                                            <h3 className="small-medium-text fw-600 mb-0">Solution</h3>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div
                                                                                        className="borderBottom dotted orangeAccentColor"
                                                                                        style={{ fontStyle: "italic", cursor: 'pointer', borderBottom: '1px dotted #F6821F' }}
                                                                                        onClick={() => handleToggleSolution(`${index}-${subIndex}`)}
                                                                                    >
                                                                                        <h3 className="small-medium-text fw-600 orangeAccentColor mb-0">
                                                                                            {openIndex === `${index}-${subIndex}` ? 'Hide' : 'Show'}
                                                                                        </h3>
                                                                                    </div>
                                                                                </div>) : null}
                                                                            {openIndex === `${index}-${subIndex}` && (
                                                                                <div className="mt-3" style={{ lineHeight: '24px' }}>
                                                                                    <div className="small-medium-text fw-600">
                                                                                        {subQ?.typeOfQuestion === 'Poem' || 'Comprehensive' ? (

                                                                                            <div className="w-100 blog-data-html mt-2" style={{ contain: "content" }}>
                                                                                                {cleanQuestionText(subQ.solution) && parse(cleanQuestionText(subQ.solution), { replace: customParser })}
                                                                                            </div>

                                                                                        ) : (
                                                                                            null
                                                                                        )}
                                                                                    </div>

                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    )
                                                                })}
                                                            </div>
                                                        ) : (
                                                            <div>
                                                                <div className="d-flex justify-content-between">
                                                                    {q?.typeOfQuestion === 'General' ? (

                                                                        <div className=" blog-data-html " style={{ contain: "content", width: '90%' }}>

                                                                            {cleanQuestionText(q.question) && parse(cleanQuestionText(q.question), { replace: customParser })}

                                                                        </div>

                                                                    ) : (
                                                                        null
                                                                    )}

                                                                    <div>
                                                                        {q.selectedOption == null ? (
                                                                            <span style={{ color: "#FF0000" }}>Not Answered</span>
                                                                        ) : (
                                                                            null
                                                                        )}
                                                                    </div>
                                                                </div>

                                                                <ol className="list-group my-4">
                                                                    {q.options.map((option, optIndex) => {
                                                                        const isUserSelected = q.selectedOption === optIndex;
                                                                        const isCorrectOption = q.correctOption === optIndex;

                                                                        return (
                                                                            <li
                                                                                key={optIndex}
                                                                                className="list-group-item d-flex gap-2 justify-content-between align-items-start border-0 py-0"
                                                                                style={{
                                                                                    color: isCorrectOption ? 'green' : (isUserSelected && !isCorrectOption) ? 'red' : 'inherit',
                                                                                }}
                                                                            >
                                                                                <div className="ms-2 me-auto form-check d-flex align-items-center p-0">
                                                                                    <div className="checkmarks"
                                                                                        style={{
                                                                                            border: isCorrectOption ? 'none' : (isUserSelected && !isCorrectOption ? 'red' : '1px solid #ccc'),
                                                                                            backgroundColor: isCorrectOption ? 'green' : (isUserSelected && !isCorrectOption ? 'red' : 'white'),
                                                                                            marginBottom: "16px"
                                                                                        }}
                                                                                    >
                                                                                        {isUserSelected && !isCorrectOption ? <HiX style={{ fontSize: '16px' }} /> : (isCorrectOption ? <FaCheck style={{ fontSize: '15px' }} /> : '')}                                                                  </div>
                                                                                    <label
                                                                                        className="form-check-label small-medium-text fw-500 px-2"
                                                                                        htmlFor={`General-option-${index}-${optIndex}`}
                                                                                    >
                                                                                        <div className="d-flex gap-2">
                                                                                            <span style={{ marginTop: '2px' }}>{getAlphabetLabel(optIndex)}. </span> <span><p>{cleanQuestionText(option) && parse(cleanQuestionText(option), { replace: customParser })}</p></span>
                                                                                            <div style={{ marginTop: '2px' }}>
                                                                                                {isCorrectOption && !isUserSelected && (
                                                                                                    <span className="small-text ms-3 fw-600" style={{ fontStyle: 'italic' }}>Correct Answer</span>
                                                                                                )}
                                                                                                {isUserSelected && !isCorrectOption && (
                                                                                                    <span className="text-danger small-text ms-3 fw-600" style={{ fontStyle: 'italic' }}>Incorrect Answer</span>
                                                                                                )}
                                                                                                {isUserSelected && isCorrectOption && (
                                                                                                    <span className="small-text ms-3 fw-600" style={{ fontStyle: 'italic' }}>Your Answer</span>
                                                                                                )}
                                                                                            </div>
                                                                                        </div>
                                                                                    </label>
                                                                                </div>
                                                                            </li>
                                                                        );
                                                                    })}
                                                                </ol>{
                                                                    q.solution !== "" ? (
                                                                        <div className="d-flex gap-2 align-items-center mt-2">
                                                                            <div className='d-flex gap-1 align-items-center'>
                                                                                <Image src={PngImages.light_bulb} alt="Light Bulb Icon" />
                                                                                <div>
                                                                                    <h3 className="small-medium-text fw-600 mb-0">Solution</h3>
                                                                                </div>
                                                                            </div>
                                                                            <div
                                                                                className="borderBottom dotted orangeAccentColor"
                                                                                style={{ fontStyle: "italic", cursor: 'pointer', borderBottom: '1px dotted #F6821F' }}
                                                                                onClick={() => handleToggleSolution(index)}
                                                                            >
                                                                                <h3 className="small-medium-text fw-600 orangeAccentColor mb-0">
                                                                                    {openIndex === index ? 'Hide' : 'Show'}
                                                                                </h3>
                                                                            </div>
                                                                        </div>
                                                                    ) : null}
                                                                {openIndex === index && (
                                                                    // <div className="mt-3" style={{ lineHeight: '24px' }}>
                                                                    //     <div className="small-medium-text fw-600">{decodeHtml(q.solution?.replace(/&nbsp;/g, ' '))}</div>
                                                                    // </div>
                                                                    <div className="mt-3" style={{ lineHeight: '24px' }}>
                                                                        <div className="small-medium-text fw-600">
                                                                            {q?.typeOfQuestion === 'General' ? (

                                                                                <div className="w-100 blog-data-html mt-2" style={{ contain: "content" }}>
                                                                                    {cleanQuestionText(q.solution) && parse(cleanQuestionText(q.solution), { replace: customParser })}
                                                                                </div>

                                                                            ) : (
                                                                                null
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                )
                                            })}</>)}
                            </section>
                            <div className="d-flex flex-wrap justify-content-between align-items-center small-medium-text fw-400 px-2 gap-2">
                                <SubmitButtonTwo
                                    title={'Previous'}
                                    className="previewbtn"
                                    onclick={() => handleSubjectChange('previous')} // Previous button
                                    disabled={currentSubjectIndex === 0} // Disable if first subject
                                />

                                <div className="d-flex gap-3">
                                    <SubmitButtonTwo
                                        className="nextbtn"
                                        title={'Next'}
                                        onclick={() => handleSubjectChange('next')} // Next button
                                        disabled={currentSubjectIndex === subjects.length - 1} // Disable if last subject
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewResults;
